<template>
  <div class="rk-switch">
    <div
      v-if="spread"
      :style="{
        '--grid-template-columns': options[0].length
      }"
      class="rk-switch--spread"
    >
      <div
        v-for="(item, index) in gridList"
        :key="index"
        :class="{ 'rk-switch-item--active': item.value === activeName, [item.class ?? '']: true }"
        class="rk-switch-item"
        @click="$emit('change', item.value)"
      >
        {{ $t(item.label) }}
      </div>
    </div>
    <div class="rk-btn" v-else>
      <div
        class="btn-switch"
        v-for="item in gridList"
        :key="item.value"
        :class="[item.value === activeName ? 'active' : '']"
        @click="$emit('change', item.value)"
      >
        {{ $t(item.label) }}
      </div>
    </div>
  </div>
</template>

<script>
import BtnTabs from '@/components/common/BtnTabs'
export default {
  components: { BtnTabs },
  model: {
    prop: 'activeName',
    event: 'change'
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    activeName: {
      required: true
    },
    spread: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    gridList() {
      return this.options.flat()
    }
  }
}
</script>

<style lang="scss" scoped>
.rk-switch {
  --border-radius: 4px;
  font-size: 13px;
  color: var(--font-color-3);
  background: var(--bg-color-2);
  white-space: nowrap;
}
.rk-switch--spread {
  display: grid;
  grid-template-columns: repeat(var(--grid-template-columns), auto);
  grid-row-gap: 18px;
  grid-column-gap: 10px;
  .rk-switch-item {
    padding: 4px 0;
    border: 1px solid var(--border-color-2);
    border-radius: var(--border-radius);
    text-align: center;
  }
  .rk-switch-item--active {
    font-weight: 600;
    border: 1px solid var(--font-color-1);
    color: var(--font-color-1);
  }
}
.rk-switch--poly {
  margin: 0 auto;
  border-spacing: 0;
  border: 1px solid var(--border-color-2);
  border-radius: var(--border-radius);
  .rk-switch-item {
    padding: 6px;
    &:not(:first-child) {
      border-left: 1px solid var(--border-color-2);
    }
  }
  .rk-switch-item--active {
    position: relative;
    color: var(--font-color-1);
    background: var(--bg-color-4);
    &::after {
      position: absolute;
      content: '';
      left: -1px;
      right: -1px;
      top: -1px;
      bottom: -1px;
      border: 1px solid var(--font-color-1);
      z-index: 2;
    }
  }
  .rk-switch-row:first-child {
    .rk-switch-item {
      &:first-child {
        border-top-left-radius: var(--border-radius);
        &::after {
          border-top-left-radius: var(--border-radius);
        }
      }
      &:last-child {
        border-top-right-radius: var(--border-radius);
        &::after {
          border-top-right-radius: var(--border-radius);
        }
      }
    }
  }
  .rk-switch-row:last-child {
    .rk-switch-item {
      &:first-child {
        border-bottom-left-radius: var(--border-radius);
        &::after {
          border-bottom-left-radius: var(--border-radius);
        }
      }
      &:last-child {
        border-bottom-right-radius: var(--border-radius);
        &::after {
          border-bottom-right-radius: var(--border-radius);
        }
      }
    }
  }
}
.rk-btn {
  display: flex;
  gap: 15px;
  .btn-switch {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    padding: 4px 6px;
    border: 1px solid #a4b5c17f;
    border-radius: 9999px;
    &.active {
      font-weight: bold;
      border-color: var(--font-color-1);
      color: var(--font-color-1);
    }
  }
}
</style>
